/**
 * PostHog custom event tracking — Shopify
 */
(function () {
    "use strict";
  
    // ---------------------------------------------------------------------
    // Util dasar
    // ---------------------------------------------------------------------
  
    function capture(name, props) {
      try {
        if (typeof posthog !== "undefined" && posthog && typeof posthog.capture === "function") {
          posthog.capture(name, props || {});
        }
      } catch (e) {}
    }
  
    function getThemeData() {
      return (window && window.phThemeData) || {};
    }
  
    var firedOnce = {};
    function once(key, fn) {
      if (!firedOnce[key]) {
        firedOnce[key] = true;
        fn();
      }
    }
  
    function toNumber(v) {
      var n = parseFloat(v);
      return isNaN(n) ? 0 : n;
    }
  
    function identifyCustomer() {
      var customer = getThemeData().customer;
      if (customer && customer.id) {
        once("identify_user", function () {
          try {
            if (typeof posthog !== "undefined" && posthog && typeof posthog.identify === "function") {
              posthog.identify(String(customer.id), {
                email: customer.email,
                name: customer.name
              });
            }
          } catch (e) {}
        });
      }
    }
  
    function firePageview() {
      once("pageview", function () {
        var data = getThemeData();
        var props = {
          path: window.location.pathname + window.location.search,
          referrer: document.referrer || "",
          page_type: data.pageType || "other"
        };
        if (data.pageType === "product" && data.product) {
          props.product_id = data.product.id;
          props.product_name = data.product.title;
          props.category = data.product.type;
          props.price = toNumber(data.product.price);
          props.currency = data.currency || "IDR";
        }
        capture("$pageview", props);
      });
    }
  
    // ---------------------------------------------------------------------
    // search_performed
    // ---------------------------------------------------------------------
  
    function fireSearch() {
      var data = getThemeData();
      if (data.pageType !== "search") return;
      once("search_performed", function () {
        var params = new URLSearchParams(window.location.search);
        capture("search_performed", {
          query: params.get("q") || "",
          results_count:
            typeof data.searchResultsCount === "number" ? data.searchResultsCount : null
        });
      });
    }
  
    // ---------------------------------------------------------------------
    // variant_selected
    // ---------------------------------------------------------------------
  
    // Theme ini tidak memakai data-section-type, jadi sumbernya dideteksi dari
    // class kartu yang benar-benar ada di markup, dengan data-section-type
    // tetap dihormati kalau suatu saat ditambahkan.
    function getSourceSection(el) {
      if (!el || typeof el.closest !== "function") {
        return getThemeData().pageType === "product" ? "pdp" : "archive";
      }

      var tagged = el.closest("[data-section-type]");
      var type = tagged ? tagged.getAttribute("data-section-type") : "";
      if (type === "quick-view") return "quick_view";
      if (type === "featured-collection" || type === "best-sellers") return "best_sellers";

      if (el.closest(".variant-popup")) return "quick_view";
      if (el.closest(".best-sellers-card, .our-bestseller-card")) return "best_sellers";
      if (getThemeData().pageType === "product") return "pdp";
      return "archive";
    }
  
    function bindVariantSelect() {
      document.addEventListener("change", function (e) {
        var el = e.target;
        if (!el || el.tagName !== "SELECT" || el.name !== "id") return;
        var form = el.closest("form");
        if (!form) return;
        var selected = el.options[el.selectedIndex];
        var data = getThemeData();
        capture("variant_selected", {
          product_id: form.getAttribute("data-product-id") || (data.product && data.product.id) || "",
          product_name: form.getAttribute("data-product-title") || (data.product && data.product.title) || "",
          variant_name: selected ? selected.textContent.trim() : "",
          source_section: getSourceSection(form)
        });
      });
    }
  
    // ---------------------------------------------------------------------
    // util add to cart
    // ---------------------------------------------------------------------
  
    var cartHandlers = [];
    var lastCartSnapshot = null; 
  
    function registerCartHandler(matchStr, onResponse) {
      cartHandlers.push({ match: matchStr, onResponse: onResponse });
    }
  
    function runHandlers(url, reqBody, resJson) {
      for (var i = 0; i < cartHandlers.length; i++) {
        if (url.indexOf(cartHandlers[i].match) !== -1) {
          try {
            cartHandlers[i].onResponse(reqBody, resJson, url);
          } catch (e) {}
        }
      }
    }
  
    function patchNetwork() {
      var origFetch = window.fetch;
      if (typeof origFetch === "function") {
        window.fetch = function (input, init) {
          var url = typeof input === "string" ? input : (input && input.url) || "";
          var reqBody = (init && init.body) || null;
          var result = origFetch.apply(window, arguments);
          // Cabang observasi ini sengaja dipisah dan di-catch sendiri supaya
          // request yang gagal tidak memunculkan unhandled rejection.
          result
            .then(function (res) {
              res
                .clone()
                .json()
                .then(function (json) {
                  runHandlers(url, reqBody, json);
                })
                .catch(function () {});
            })
            .catch(function () {});
          return result;
        };
      }
  
      var XHR = window.XMLHttpRequest;
      var origOpen = XHR.prototype.open;
      var origSend = XHR.prototype.send;
      XHR.prototype.open = function (method, url) {
        this._phUrl = String(url || "");
        return origOpen.apply(this, arguments);
      };
      XHR.prototype.send = function (body) {
        var xhr = this;
        var url = xhr._phUrl || "";
        xhr.addEventListener("load", function () {
          try {
            var json = JSON.parse(xhr.responseText);
            runHandlers(url, body, json);
          } catch (e) {}
        });
        return origSend.apply(this, arguments);
      };
    }
  
    // cache cart object 
    function cacheCartSnapshot(cartJson) {
      if (cartJson && cartJson.items) {
        lastCartSnapshot = cartJson;
      }
    }
  
    // /cart/change.js di theme ini dipanggil dengan line item key
    // ("41234:abcdef..."), bukan variant_id, jadi cocokkan keduanya.
    function findItemInSnapshot(lineId) {
      if (!lastCartSnapshot || !lastCartSnapshot.items) return null;
      var needle = String(lineId);
      for (var i = 0; i < lastCartSnapshot.items.length; i++) {
        var item = lastCartSnapshot.items[i];
        if (
          String(item.key) === needle ||
          String(item.variant_id) === needle ||
          String(item.id) === needle
        ) {
          return item;
        }
      }
      return null;
    }

    // Body request cart bisa berupa JSON string, urlencoded string, FormData,
    // atau object biasa. Versi lama hanya menangani dua yang terakhir, sehingga
    // JSON.stringify({id, quantity}) dari cart.liquid tidak pernah terbaca.
    function parseCartRequestBody(reqBody) {
      if (!reqBody) return null;

      if (typeof FormData !== "undefined" && reqBody instanceof FormData) {
        var fromForm = {};
        reqBody.forEach(function (value, key) {
          fromForm[key] = value;
        });
        return fromForm;
      }

      if (typeof reqBody === "object") return reqBody;
      if (typeof reqBody !== "string") return null;

      var trimmed = reqBody.replace(/^\s+/, "");
      if (trimmed.charAt(0) === "{") {
        try {
          return JSON.parse(trimmed);
        } catch (e) {
          return null;
        }
      }

      var parsed = {};
      new URLSearchParams(trimmed).forEach(function (value, key) {
        parsed[key] = value;
      });
      return parsed;
    }
  
    // ---- product_added_to_cart ----
    function bindAddToCart() {
      registerCartHandler("/cart/add", function (reqBody, resJson) {
        var items = resJson && resJson.items ? resJson.items : resJson && resJson.id ? [resJson] : [];
        items.forEach(function (item) {
          capture("product_added_to_cart", {
            product_id: item.product_id,
            product_name: item.product_title || item.title,
            category: item.product_type || "",
            variant: item.variant_title || "",
            price: toNumber(item.price) / 100,
            quantity: item.quantity,
            currency: getThemeData().currency || "IDR",
            source_section: getThemeData().pageType === "product" ? "pdp" : "archive"
          });
        });
      });
  
    }
  
    // ---- 5b. product_removed_from_cart (quantity diset ke 0) ----
    function bindCartChange() {
      ["/cart/change", "/cart/update"].forEach(function (endpoint) {
        registerCartHandler(endpoint, function (reqBody, resJson) {
          var body = parseCartRequestBody(reqBody);
          var lineId = body && body.id != null ? body.id : null;
          var lineIndex = body && body.line != null ? parseInt(body.line, 10) : null;
          var qty = body ? body.quantity : null;

          // Item dicari di snapshot LAMA. Response /cart/change.js adalah isi
          // keranjang SESUDAH penghapusan, jadi item yang dihapus sudah hilang
          // dari sana — snapshot harus dibaca sebelum ditimpa.
          var item = null;
          if (lineId != null) {
            item = findItemInSnapshot(lineId);
          } else if (lineIndex && lastCartSnapshot && lastCartSnapshot.items) {
            item = lastCartSnapshot.items[lineIndex - 1] || null;
          }

          cacheCartSnapshot(resJson);

          if ((lineId != null || lineIndex) && parseInt(qty, 10) === 0) {
            capture("product_removed_from_cart", {
              product_id: item ? item.product_id : "",
              product_name: item ? item.product_title || item.title : "",
              variant: item ? item.variant_title || "" : "",
              quantity: item ? item.quantity : null,
              price: item ? toNumber(item.price) / 100 : null,
              currency: getThemeData().currency || "IDR"
            });
          }
        });
      });
    }
  
    // ---- 5c. seed snapshot dari Liquid, supaya penghapusan item tetap
    //          teridentifikasi walaupun belum ada request /cart.js sama sekali ----
    function seedCartSnapshot() {
      cacheCartSnapshot(getThemeData().cart);
    }

    // ---- 5d. cache snapshot dari /cart.js kalau ada yang fetch cart biasa ----
    function bindCartSnapshotSync() {
      registerCartHandler("/cart.js", function (_, resJson) {
        cacheCartSnapshot(resJson);
      });
    }
  
    // ---------------------------------------------------------------------
    // 6. checkout_started — klik tombol checkout di halaman cart
    // ---------------------------------------------------------------------
  
    function bindCheckoutStarted() {
      document.addEventListener("click", function (e) {
        var el = e.target.closest(
          'a[href="/checkout"], a[href^="/checkout?"], button[name="checkout"], input[name="checkout"]'
        );
        if (!el) return;
        if (getThemeData().pageType !== "cart") return;
        var cart = lastCartSnapshot;
        capture("checkout_started", {
          cart_total: cart ? toNumber(cart.total_price) / 100 : null,
          item_count: cart ? cart.item_count : null,
          currency: getThemeData().currency || "IDR"
        });
      });
    }
  
    // ---------------------------------------------------------------------
    // 6b. Buy Now (PDP) — tombolnya tidak memakai /cart/add.js, melainkan
    //     berpindah halaman ke permalink /cart/<variant>:<qty>. Karena tidak
    //     ada request yang bisa diintip, product.js memanggil hook ini tepat
    //     sebelum navigasi (yaitu hanya kalau validasi stok lolos).
    // ---------------------------------------------------------------------

    function exposeBuyNowHook() {
      window.phTrackBuyNow = function (variantId, quantity, variant) {
        var data = getThemeData();
        var product = data.product || {};
        capture("product_added_to_cart", {
          product_id: product.id || "",
          product_name: product.title || "",
          category: product.type || "",
          variant_id: variantId,
          variant: variant && variant.title ? variant.title : "",
          price: variant ? toNumber(variant.price) / 100 : toNumber(product.price),
          quantity: parseInt(quantity, 10) || 1,
          currency: data.currency || "IDR",
          source_section: "pdp",
          method: "buy_now"
        });
      };
    }

    // ---------------------------------------------------------------------
    // 7. banner_clicked — hero banner & recommendation banners.
    //    Markup menaruh data-banner-name / data-banner-category di elemen
    //    pembungkus slide, jadi semua jalur klik di dalamnya ikut tertangkap:
    //    link gambar maupun tombol CTA. Gambar desktop & mobile memakai satu
    //    <img> yang sama (beda <source> saja), sehingga dua-duanya terpakai.
    // ---------------------------------------------------------------------

    function bindBannerClicked() {
      document.addEventListener("click", function (e) {
        var target = e.target;
        if (!target || typeof target.closest !== "function") return;

        // Hanya klik yang benar-benar menuju sebuah link yang dihitung,
        // supaya klik untuk menggeser slide tidak ikut terkirim.
        var link = target.closest("a[href]");
        if (!link) return;

        var banner = link.closest("[data-banner-name]");
        if (!banner) return;

        capture("banner_clicked", {
          banner_name: banner.getAttribute("data-banner-name") || "",
          banner_category: banner.getAttribute("data-banner-category") || "",
          link_url: link.getAttribute("href") || "",
          page: window.location.pathname
        });
      });
    }

    // ---------------------------------------------------------------------
    // 8. Event custom generik lewat data-attribute — buat banner, WhatsApp,
    //    social link, atau elemen lain yang kamu bikin sendiri di markup.
    //    Contoh markup:
    //      <a href="https://wa.me/..." data-ph-event="whatsapp_clicked"
    //         data-ph-props='{"page":"product"}'>Chat kami</a>
    // ---------------------------------------------------------------------
  
    function bindCustomDataEvents() {
      document.addEventListener("click", function (e) {
        var el = e.target.closest("[data-ph-event]");
        if (!el) return;
        var name = el.getAttribute("data-ph-event");
        var propsAttr = el.getAttribute("data-ph-props");
        var props = {};
        if (propsAttr) {
          try {
            props = JSON.parse(propsAttr);
          } catch (e) {}
        }
        props.page = window.location.pathname;
        capture(name, props);
      });
    }
  
    // ---------------------------------------------------------------------
    // Bootstrap
    // ---------------------------------------------------------------------
  
    function init() {
      patchNetwork();
      identifyCustomer();
      firePageview();
      fireSearch();
      bindVariantSelect();
      bindAddToCart();
      bindCartChange();
      seedCartSnapshot();
      bindCartSnapshotSync();
      exposeBuyNowHook();
      bindCheckoutStarted();
      bindBannerClicked();
      bindCustomDataEvents();
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();